// src/store/store.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import biasesReducer from './slices/biasesSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    biases: biasesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
